<section>
  <div
    class="notes"
    *ngIf="
      noteContent &&
      (quote.quoteState === quoteStateType.REQUEST_APPROVED ||
        quote.quoteState === quoteStateType.REQUEST_REJECTED ||
        quote.quoteState === quoteStateType.OFFER_ACCEPTED ||
        quote.quoteState === quoteStateType.OFFER_REJECTED)
    "
  >
    <h4>{{ noteTitle }}</h4>
    <p>
      <em>{{ noteContent }}</em>
    </p>
  </div>
</section>
